// Module
var code = "<div class=\"row\"> <div class=\"col-md-offset-2 col-md-8\"> <remote-paged-grid-layout title-label-code=\"'settings.booths'\" new-entity-label-code=\"'setting.booths.new'\" new-entity-enabled=\"canCreate\" columns=\"columns\" find-page=\"findPage\" sort-info=\"sortInfo\"></remote-paged-grid-layout> </div> </div> ";
// Exports
export default code;